var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PolicyStepsHeader from '../../../common/PolicyStepsHeader';
import useWidgetStore from '../../../../stores/widgetStore';
var NoPaymentPurchase = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var setSelectedPlan = _a.setSelectedPlan, purchaseQuoteMutation = _a.purchaseQuoteMutation, onSuccess = _a.onSuccess, _h = _a.isLoading, isLoading = _h === void 0 ? false : _h, quoteId = _a.quoteId, selectedPlan = _a.selectedPlan;
    var _j = useState(false), isSubmitting = _j[0], setIsSubmitting = _j[1];
    var _k = useWidgetStore(), setPolicyPaymentPayloads = _k.setPolicyPaymentPayloads, setSelectedPolicyPayload = _k.setSelectedPolicyPayload, unifiedState = _k.unifiedState;
    var quote = (_b = unifiedState.activeQuote) === null || _b === void 0 ? void 0 : _b.quote;
    var quoteData = {
        carrier: (_c = quote === null || quote === void 0 ? void 0 : quote.policyType) === null || _c === void 0 ? void 0 : _c.underwriter,
        product: (_d = quote === null || quote === void 0 ? void 0 : quote.policyType) === null || _d === void 0 ? void 0 : _d.label,
        quoteId: quote === null || quote === void 0 ? void 0 : quote.quoteExternalReference,
        occurrenceLimit: (_e = quote === null || quote === void 0 ? void 0 : quote.limits) === null || _e === void 0 ? void 0 : _e.occurrence,
        aggregateLimit: (_f = quote === null || quote === void 0 ? void 0 : quote.limits) === null || _f === void 0 ? void 0 : _f.aggregate,
        deductible: (_g = quote === null || quote === void 0 ? void 0 : quote.limits) === null || _g === void 0 ? void 0 : _g.deductible
    };
    var activeFreq = quote.frequencies.find(function (f) { return f.isSelected; });
    var detailRow = function (label, value) { return (React.createElement("div", { className: "flex justify-between py-1.5 text-[14px]" },
        React.createElement("span", { className: "text-gray-500 font-medium" }, label),
        React.createElement("span", { className: "text-gray-900 font-bold" }, value))); };
    var onPurchase = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paymentPayload, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    paymentPayload = {
                        externalQuoteId: quoteId,
                        installmentFrequency: selectedPlan['installmentFrequency'],
                        quoteKey: selectedPlan.quoteKey,
                        collectPayment: false
                    };
                    return [4 /*yield*/, purchaseQuoteMutation(paymentPayload)];
                case 2:
                    _a.sent();
                    setPolicyPaymentPayloads([]);
                    setSelectedPolicyPayload(null);
                    if (onSuccess) {
                        onSuccess();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.log('error in purchase', err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "w-full flex flex-col items-center justify-start" },
        React.createElement("div", { className: "w-full" },
            React.createElement(PolicyStepsHeader, { pageName: 'Confirm Purchase', nextButtonText: 'Confirm & Bind Policy', backButtonText: "Cancel", handleClose: function () {
                    setSelectedPlan(null);
                    setPolicyPaymentPayloads([]);
                    setSelectedPolicyPayload(null);
                }, handleNext: onPurchase, shouldConfirm: true, isNextDisabled: isLoading || isSubmitting })),
        React.createElement("div", { className: "max-w-[600px] font-sans overflow-y-auto" },
            React.createElement("div", { className: "p-6 pb-4 flex gap-4 items-start" },
                React.createElement("div", { className: "flex-shrink-0 mt-1" },
                    React.createElement(FontAwesomeIcon, { icon: faCheckCircle, className: "text-[#27A376] text-2xl opacity-20" })),
                React.createElement("div", { className: "flex flex-col" },
                    React.createElement("h2", { className: "text-[20px] font-bold text-[#111827] leading-tight" }, "Confirm your intent to purchase"),
                    React.createElement("p", { className: "text-[14px] text-gray-500 mt-1" }, "Review the quote details and confirm below."))),
            React.createElement("div", { className: "px-6 pb-6" },
                React.createElement("div", { className: "border border-gray-200 rounded-xl p-6 bg-white" },
                    React.createElement("div", { className: "space-y-0.5" },
                        detailRow('Carrier', quoteData.carrier),
                        detailRow('Product', quoteData.product),
                        detailRow('Quote ID', quoteData.quoteId),
                        detailRow('Occurrence Limit', quoteData.occurrenceLimit),
                        detailRow('Aggregate Limit', quoteData.aggregateLimit),
                        detailRow('Deductible', quoteData.deductible)),
                    React.createElement("div", { className: "my-4 pt-4 border-t border-gray-100 flex justify-between items-center" },
                        React.createElement("span", { className: "text-gray-600 font-medium text-[15px]" }, "Total Premium"),
                        React.createElement("span", { className: "text-[32px] font-bold text-gray-900 leading-none" }, activeFreq.totalDisplay)),
                    React.createElement("div", { className: "space-y-0.5" },
                        detailRow('Downpayment', activeFreq.downpaymentDisplay),
                        (activeFreq === null || activeFreq === void 0 ? void 0 : activeFreq.installmentCount) > 0 ? (React.createElement(React.Fragment, null, detailRow('Installments', "".concat(activeFreq.installmentCount, " x ").concat(activeFreq.installmentFormatted)))) : null)),
                React.createElement("div", { className: "mt-6 bg-[#F5F3FF] border border-[#E9E4FF] rounded-xl p-4 flex gap-3" },
                    React.createElement("div", { className: "flex-shrink-0 mt-0.5" },
                        React.createElement(FontAwesomeIcon, { icon: faInfoCircle, className: "text-[#7C3AED] text-lg" })),
                    React.createElement("div", { className: "text-[13px] leading-[1.6] text-gray-700" },
                        React.createElement("p", { className: "font-bold text-gray-900 inline" },
                            "Payment will be arranged separately by ",
                            quoteData.carrier,
                            "."),
                        React.createElement("span", { className: "ml-1 text-gray-600" }, "Online payment is not available for this carrier at this time."),
                        React.createElement("p", { className: "mt-3" },
                            "By confirming below, your policy will be bound and",
                            ' ',
                            quoteData.carrier,
                            " will contact you directly within 2 business days to arrange premium payment. Coverage is effective as of the policy effective date, subject to the terms and conditions you have accepted.")))))));
};
export default NoPaymentPurchase;
